<template>
  <div id="gifan" v-if="!hideAnimation">
    <img class="cross" :src="require('@/assets/images/nycross.svg')" @click="hide" />
    <img class="main" :src="gifUrl" />
  </div>
</template>

<script>
  import Cookies from 'js-cookie'

  export default {
    name: 'GifAnimation',
    data () {
      return {
        animationKey: 'hidedsv',
        hideAnimation: false
      }
    },
    computed: {
      gifUrl () {
        if (process.env.NODE_ENV === 'production') {
          return '/wp-content/themes/welbempty/vue/static/dsv.gif'
        } else {
          return '/static/dsv.gif'
        }
      }
    },
    methods: {
      hide () {
        Cookies.set('hidedsv', 'true', { expires: 2 })
        this.hideAnimation = true
      }
    },
    mounted () {
      this.hideAnimation = (Boolean)(Cookies.get('hidedsv'))
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GifAnimation.vue